import classNames from 'classnames';
import React, { useState } from 'react';
import { Waypoint } from 'react-waypoint';
import Sizes from '../utils/responsive/Sizes';
import isSize from '../utils/responsive/isSize';
import styles from './StickyHeader.module.scss';
import useTopbarHeight from '../topbar/useTopbarHeight';

interface StickyHeaderProps {
  children: React.ReactNode;
  topbarAware?: boolean;
  stuck?: boolean;
  onStuckChange?: (stuckChange: boolean) => void;
  topOffset?: number;
}

interface UnmanagedStickyHeaderProps extends StickyHeaderProps {
  stuck: boolean;
  onStuckChange: (stuckChange: boolean) => void;
}

const UnmanagedStickyHeader = ({
  children,
  stuck,
  onStuckChange,
  topbarAware = false,
  topOffset,
}: UnmanagedStickyHeaderProps) => {
  const topbarHeight = useTopbarHeight();

  return (
    <>
      <Waypoint
        onPositionChange={({ currentPosition }) =>
          onStuckChange(currentPosition === Waypoint.above)
        }
        topOffset={
          topOffset ??
          (isSize(Sizes.SM) && topbarAware && topbarHeight != null
            ? topbarHeight
            : 0)
        }
      />
      <div
        className={classNames(styles.container, {
          [styles.topbarAware]: topbarAware,
          [styles.stuck]: stuck,
        })}
        style={topOffset != null ? { top: topOffset } : undefined}
      >
        <div className={styles.header}>{children}</div>
      </div>
    </>
  );
};

const StickyHeader = (props: StickyHeaderProps) => {
  const [isStuck, setIsStuck] = useState(false);

  return (
    <UnmanagedStickyHeader
      stuck={isStuck}
      onStuckChange={setIsStuck}
      {...props}
    />
  );
};

export default StickyHeader;
